import React from "react";
import botcircuitsLogo from "../../assets/others/logo.png";

// "Powered by <logo> BotCircuits", shared by the chat window and the text bar.
export default function PoweredBy({ className = "" }) {
  return (
    <p className={`chat-powered-by ${className}`.trim()}>
      <span>Powered by</span>
      <a href="https://www.botcircuits.com" target="_blank" rel="noopener noreferrer">
        <img src={botcircuitsLogo} alt="" aria-hidden="true" draggable={false} />
        BotCircuits
      </a>
    </p>
  );
}
